import Module from '../../../module';
import scroll from '../../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			investorsResourcesMediaCoverageHeroContentSectionHeaderCls: string;
		}
	},

	slug: string
}

class Hero extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Investors Resources Media Coverage Hero Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesMediaCoverageHeroContentSectionHeaderCls || '', 'investors_resources_media_coverage_hero', { animCls: 'animate__fadeInDown', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Hero;